import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, HostBinding, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { TuiMonth, TUI_FIRST_DAY, TUI_LAST_DAY, ALWAYS_FALSE_HANDLER, TuiMonthRange, TuiYear, inRange, tuiDefaultProp, TuiHoveredModule, TuiPressedModule, TuiRepeatTimesModule, TuiLetModule } from '@taiga-ui/cdk';
import { TuiScrollIntoViewModule } from '@taiga-ui/core/directives/scroll-into-view';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk';
import * as ɵngcc2 from '@taiga-ui/core/directives/scroll-into-view';

function TuiPrimitiveYearPickerComponent_div_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵlistener("tuiHoveredChange", function TuiPrimitiveYearPickerComponent_div_0_ng_container_1_div_1_Template_div_tuiHoveredChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.tuiLet; const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.onItemHovered($event, item_r5); })("tuiPressedChange", function TuiPrimitiveYearPickerComponent_div_0_ng_container_1_div_1_Template_div_tuiPressedChange_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.tuiLet; const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.onItemPressed($event, item_r5); })("click", function TuiPrimitiveYearPickerComponent_div_0_ng_container_1_div_1_Template_div_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const item_r5 = restoredCtx.tuiLet; const ctx_r9 = ɵngcc0.ɵɵnextContext(3); return ctx_r9.onItemClick(item_r5); });
    ɵngcc0.ɵɵelementStart(1, "div", 5);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r5 = ctx.tuiLet;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassProp("t-cell_today", ctx_r4.itemIsToday(item_r5))("t-cell_interval", ctx_r4.itemIsInterval(item_r5));
    ɵngcc0.ɵɵproperty("tuiScrollIntoView", ctx_r4.scrollItemIntoView(item_r5));
    ɵngcc0.ɵɵattribute("data-range", ctx_r4.getItemRange(item_r5))("data-state", ctx_r4.getItemState(item_r5));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r5);
} }
function TuiPrimitiveYearPickerComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, TuiPrimitiveYearPickerComponent_div_0_ng_container_1_div_1_Template, 3, 8, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const colIndex_r3 = ctx.$implicit;
    const rowIndex_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tuiLet", ctx_r2.getItem(rowIndex_r1, colIndex_r3));
} }
function TuiPrimitiveYearPickerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, TuiPrimitiveYearPickerComponent_div_0_ng_container_1_Template, 2, 1, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("tuiRepeatTimesOf", 4);
} }
const LIMIT = 100;
const ITEMS_IN_ROW = 4;
let TuiPrimitiveYearPickerComponent = class TuiPrimitiveYearPickerComponent {
    constructor() {
        this.hoveredItem = null;
        this.pressedItem = null;
        this.currentYear = TuiMonth.currentLocal().year;
        this.value = null;
        this.initialItem = TuiMonth.currentLocal();
        this.min = TUI_FIRST_DAY;
        this.max = TUI_LAST_DAY;
        this.disabledItemHandler = ALWAYS_FALSE_HANDLER;
        this.yearClick = new EventEmitter();
    }
    get isSingle() {
        const { value } = this;
        return !!value && this.isRange(value) && value.from.yearSame(value.to);
    }
    get rows() {
        return Math.ceil((this.calculatedMax - this.calculatedMin) / ITEMS_IN_ROW);
    }
    get calculatedMin() {
        const initial = this.initialItem.year - LIMIT;
        return this.min.year > initial ? this.min.year : initial;
    }
    get calculatedMax() {
        const initial = this.initialItem.year + LIMIT;
        return this.max.year < initial ? this.max.year + 1 : initial;
    }
    isRange(item) {
        return item instanceof TuiMonthRange;
    }
    scrollItemIntoView(item) {
        return this.initialItem.year === item;
    }
    getItem(rowIndex, colIndex) {
        return rowIndex * ITEMS_IN_ROW + colIndex + this.calculatedMin;
    }
    getItemState(item) {
        const { disabledItemHandler, max, pressedItem, hoveredItem } = this;
        if (max.year < item ||
            (disabledItemHandler !== ALWAYS_FALSE_HANDLER && disabledItemHandler(item))) {
            return "disabled" /* Disabled */;
        }
        if (pressedItem === item) {
            return "pressed" /* Pressed */;
        }
        if (hoveredItem === item) {
            return "hovered" /* Hovered */;
        }
        return null;
    }
    getItemRange(item) {
        const { value, hoveredItem } = this;
        if (value === null) {
            return null;
        }
        if (value instanceof TuiYear) {
            return value.year === item ? "single" /* Single */ : null;
        }
        if ((value.from.year === item && !value.from.yearSame(value.to)) ||
            (hoveredItem !== null &&
                hoveredItem > value.from.year &&
                value.from.year === item &&
                value.from.yearSame(value.to)) ||
            (hoveredItem !== null &&
                hoveredItem === item &&
                hoveredItem < value.from.year &&
                value.from.yearSame(value.to))) {
            return "start" /* Start */;
        }
        if ((value.to.year === item && !value.from.yearSame(value.to)) ||
            (hoveredItem !== null &&
                hoveredItem < value.from.year &&
                value.from.year === item &&
                value.from.yearSame(value.to)) ||
            (hoveredItem !== null &&
                hoveredItem === item &&
                hoveredItem > value.from.year &&
                value.from.yearSame(value.to))) {
            return "end" /* End */;
        }
        return value.from.yearSame(value.to) && value.from.year === item
            ? "single" /* Single */
            : null;
    }
    itemIsToday(item) {
        return this.currentYear === item;
    }
    itemIsInterval(item) {
        const { value, hoveredItem } = this;
        if (value === null || !this.isRange(value)) {
            return false;
        }
        if (!value.from.yearSame(value.to)) {
            return value.from.year <= item && value.to.year > item;
        }
        if (hoveredItem === null || value.from.year === hoveredItem) {
            return false;
        }
        return inRange(item, Math.min(value.from.year, hoveredItem), Math.max(value.from.year, hoveredItem));
    }
    onItemHovered(hovered, item) {
        this.updateHoveredItem(hovered, item);
    }
    onItemPressed(pressed, item) {
        this.updatePressedItem(pressed, item);
    }
    onItemClick(item) {
        this.yearClick.emit(new TuiYear(item));
    }
    updateHoveredItem(hovered, item) {
        this.hoveredItem = hovered ? item : null;
    }
    updatePressedItem(pressed, item) {
        this.pressedItem = pressed ? item : null;
    }
};
TuiPrimitiveYearPickerComponent.ɵfac = function TuiPrimitiveYearPickerComponent_Factory(t) { return new (t || TuiPrimitiveYearPickerComponent)(); };
TuiPrimitiveYearPickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiPrimitiveYearPickerComponent, selectors: [["tui-primitive-year-picker"]], hostVars: 2, hostBindings: function TuiPrimitiveYearPickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("_single", ctx.isSingle);
    } }, inputs: { value: "value", initialItem: "initialItem", min: "min", max: "max", disabledItemHandler: "disabledItemHandler" }, outputs: { yearClick: "yearClick" }, decls: 1, vars: 1, consts: [["automation-id", "tui-primitive-year-picker__row", "class", "t-row", 4, "tuiRepeatTimes", "tuiRepeatTimesOf"], ["automation-id", "tui-primitive-year-picker__row", 1, "t-row"], [4, "tuiRepeatTimes", "tuiRepeatTimesOf"], ["automation-id", "tui-primitive-year-picker__cell", "class", "t-cell", 3, "t-cell_today", "t-cell_interval", "tuiScrollIntoView", "tuiHoveredChange", "tuiPressedChange", "click", 4, "tuiLet"], ["automation-id", "tui-primitive-year-picker__cell", 1, "t-cell", 3, "tuiScrollIntoView", "tuiHoveredChange", "tuiPressedChange", "click"], [1, "t-item"]], template: function TuiPrimitiveYearPickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiPrimitiveYearPickerComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("tuiRepeatTimesOf", ctx.rows);
    } }, directives: [ɵngcc1.TuiRepeatTimesDirective, ɵngcc1.TuiLetDirective, ɵngcc2.TuiScrollIntoViewDirective, ɵngcc1.TuiHoveredDirective, ɵngcc1.TuiPressedDirective], styles: ["[_nghost-%COMP%]{display:block;font:var(--tui-font-text-m)}.t-row[_ngcontent-%COMP%]{position:relative;z-index:0;display:flex;justify-content:space-between;height:2.25rem;margin:.875rem 0}.t-item[_ngcontent-%COMP%]{position:relative;flex:1;line-height:2rem;border-radius:var(--tui-radius-m)}.t-item[_ngcontent-%COMP%]:after, .t-item[_ngcontent-%COMP%]:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;width:3.9375rem;text-align:center;outline:0;cursor:pointer;background-clip:content-box;box-sizing:border-box;border:2px solid transparent}.t-cell[_ngcontent-%COMP%]:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell_today[_ngcontent-%COMP%]:after{position:absolute;left:50%;transform:translate(-50%,0);content:'';bottom:.3125rem;height:.125rem;width:.75rem;border-radius:.375rem;background-color:var(--tui-text-02)}.t-cell_interval[_ngcontent-%COMP%]:before{background:var(--tui-base-02)}._single[_nghost-%COMP%]   .t-cell_interval[_ngcontent-%COMP%]:before{background:var(--tui-secondary-hover)}.t-cell_interval[_ngcontent-%COMP%]:not(:last-child):before{right:-3.9375rem}.t-cell_interval[_ngcontent-%COMP%]:last-child:first-child:before{right:0}.t-cell_interval[_ngcontent-%COMP%]:first-child > .t-item[_ngcontent-%COMP%]{border-top-left-radius:var(--tui-radius-m);border-bottom-left-radius:var(--tui-radius-m)}.t-cell_interval[_ngcontent-%COMP%]:last-child > .t-item[_ngcontent-%COMP%]{border-top-right-radius:var(--tui-radius-m);border-bottom-right-radius:var(--tui-radius-m)}.t-cell_interval[_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]{border-radius:0}.t-cell[data-range][_ngcontent-%COMP%]:after{background-color:var(--tui-primary-text)}.t-cell[data-range][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]{color:var(--tui-primary-text)}.t-cell[data-range][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after, .t-cell[data-range][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{background-color:var(--tui-primary)}.t-cell[data-range][data-state=hovered][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after, .t-cell[data-range][data-state=hovered][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{background-color:var(--tui-primary-hover)}.t-cell[data-range][data-state=pressed][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after, .t-cell[data-range][data-state=pressed][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{background-color:var(--tui-primary-active)}.t-cell[data-range=end][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{left:.25rem}.t-cell[data-range=end][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after{left:-2rem;right:100%;transform:translateX(1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-range=start][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:before{right:.25rem}.t-cell[data-range=start][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]:after{left:100%;right:-2rem;transform:translateX(-1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-state=disabled][_ngcontent-%COMP%]{pointer-events:none}.t-cell[data-state=disabled][_ngcontent-%COMP%] > .t-item[_ngcontent-%COMP%]{opacity:.36}.t-cell[data-state=hovered][_ngcontent-%COMP%]:hover:not([data-range]) > .t-item[_ngcontent-%COMP%]{background-color:var(--tui-secondary-hover)}.t-cell[data-state=pressed][_ngcontent-%COMP%]:hover:not([data-range]) > .t-item[_ngcontent-%COMP%]{background-color:var(--tui-secondary-active)}[_nghost-%COMP%]{width:15.75rem}.t-row[_ngcontent-%COMP%]:first-child{margin-top:0}.t-row[_ngcontent-%COMP%]:last-child{margin-bottom:0}"], changeDetection: 0 });
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearPickerComponent.prototype, "value", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearPickerComponent.prototype, "initialItem", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearPickerComponent.prototype, "min", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearPickerComponent.prototype, "max", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiPrimitiveYearPickerComponent.prototype, "disabledItemHandler", void 0);
__decorate([
    Output()
], TuiPrimitiveYearPickerComponent.prototype, "yearClick", void 0);
__decorate([
    HostBinding('class._single')
], TuiPrimitiveYearPickerComponent.prototype, "isSingle", null);

let TuiPrimitiveYearPickerModule = class TuiPrimitiveYearPickerModule {
};
TuiPrimitiveYearPickerModule.ɵfac = function TuiPrimitiveYearPickerModule_Factory(t) { return new (t || TuiPrimitiveYearPickerModule)(); };
TuiPrimitiveYearPickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiPrimitiveYearPickerModule });
TuiPrimitiveYearPickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            TuiHoveredModule,
            TuiPressedModule,
            TuiRepeatTimesModule,
            TuiLetModule,
            TuiScrollIntoViewModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveYearPickerComponent, [{
        type: Component,
        args: [{
                selector: 'tui-primitive-year-picker',
                template: "<div\n    *tuiRepeatTimes=\"let rowIndex of rows\"\n    automation-id=\"tui-primitive-year-picker__row\"\n    class=\"t-row\"\n>\n    <ng-container *tuiRepeatTimes=\"let colIndex of 4\">\n        <div\n            *tuiLet=\"getItem(rowIndex, colIndex) as item\"\n            automation-id=\"tui-primitive-year-picker__cell\"\n            class=\"t-cell\"\n            [class.t-cell_today]=\"itemIsToday(item)\"\n            [class.t-cell_interval]=\"itemIsInterval(item)\"\n            [attr.data-range]=\"getItemRange(item)\"\n            [attr.data-state]=\"getItemState(item)\"\n            [tuiScrollIntoView]=\"scrollItemIntoView(item)\"\n            (tuiHoveredChange)=\"onItemHovered($event, item)\"\n            (tuiPressedChange)=\"onItemPressed($event, item)\"\n            (click)=\"onItemClick(item)\"\n        >\n            <div class=\"t-item\">{{ item }}</div>\n        </div>\n    </ng-container>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:block;font:var(--tui-font-text-m)}.t-row{position:relative;z-index:0;display:flex;justify-content:space-between;height:2.25rem;margin:.875rem 0}.t-item{position:relative;flex:1;line-height:2rem;border-radius:var(--tui-radius-m)}.t-item:after,.t-item:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell{position:relative;display:flex;align-items:center;justify-content:center;width:3.9375rem;text-align:center;outline:0;cursor:pointer;background-clip:content-box;box-sizing:border-box;border:2px solid transparent}.t-cell:before{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;border-radius:var(--tui-radius-m)}.t-cell_today:after{position:absolute;left:50%;transform:translate(-50%,0);content:'';bottom:.3125rem;height:.125rem;width:.75rem;border-radius:.375rem;background-color:var(--tui-text-02)}.t-cell_interval:before{background:var(--tui-base-02)}:host._single .t-cell_interval:before{background:var(--tui-secondary-hover)}.t-cell_interval:not(:last-child):before{right:-3.9375rem}.t-cell_interval:last-child:first-child:before{right:0}.t-cell_interval:first-child>.t-item{border-top-left-radius:var(--tui-radius-m);border-bottom-left-radius:var(--tui-radius-m)}.t-cell_interval:last-child>.t-item{border-top-right-radius:var(--tui-radius-m);border-bottom-right-radius:var(--tui-radius-m)}.t-cell_interval>.t-item{border-radius:0}.t-cell[data-range]:after{background-color:var(--tui-primary-text)}.t-cell[data-range]>.t-item{color:var(--tui-primary-text)}.t-cell[data-range]>.t-item:after,.t-cell[data-range]>.t-item:before{background-color:var(--tui-primary)}.t-cell[data-range][data-state=hovered]>.t-item:after,.t-cell[data-range][data-state=hovered]>.t-item:before{background-color:var(--tui-primary-hover)}.t-cell[data-range][data-state=pressed]>.t-item:after,.t-cell[data-range][data-state=pressed]>.t-item:before{background-color:var(--tui-primary-active)}.t-cell[data-range=end]>.t-item:before{left:.25rem}.t-cell[data-range=end]>.t-item:after{left:-2rem;right:100%;transform:translateX(1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-range=start]>.t-item:before{right:.25rem}.t-cell[data-range=start]>.t-item:after{left:100%;right:-2rem;transform:translateX(-1.4375rem) scaleY(.6) scaleX(.4) rotate(45deg)}.t-cell[data-state=disabled]{pointer-events:none}.t-cell[data-state=disabled]>.t-item{opacity:.36}.t-cell[data-state=hovered]:hover:not([data-range])>.t-item{background-color:var(--tui-secondary-hover)}.t-cell[data-state=pressed]:hover:not([data-range])>.t-item{background-color:var(--tui-secondary-active)}:host{width:15.75rem}.t-row:first-child{margin-top:0}.t-row:last-child{margin-bottom:0}"]
            }]
    }], function () { return []; }, { value: [{
            type: Input
        }], initialItem: [{
            type: Input
        }], min: [{
            type: Input
        }], max: [{
            type: Input
        }], disabledItemHandler: [{
            type: Input
        }], yearClick: [{
            type: Output
        }], isSingle: [{
            type: HostBinding,
            args: ['class._single']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiPrimitiveYearPickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    TuiHoveredModule,
                    TuiPressedModule,
                    TuiRepeatTimesModule,
                    TuiLetModule,
                    TuiScrollIntoViewModule,
                ],
                declarations: [TuiPrimitiveYearPickerComponent],
                exports: [TuiPrimitiveYearPickerComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiPrimitiveYearPickerModule, { declarations: function () { return [TuiPrimitiveYearPickerComponent]; }, imports: function () { return [TuiHoveredModule,
        TuiPressedModule,
        TuiRepeatTimesModule,
        TuiLetModule,
        TuiScrollIntoViewModule]; }, exports: function () { return [TuiPrimitiveYearPickerComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiPrimitiveYearPickerComponent, TuiPrimitiveYearPickerModule };

